import {Injectable} from '@angular/core';
import {PhoneNumberFormat as PNF, PhoneNumberUtil} from 'google-libphonenumber';

const phoneUtil = PhoneNumberUtil.getInstance();

@Injectable({
  providedIn: 'root'
})
export class PhoneService {

  public parsePhoneNumber(rawPhone: any): any {
    try {
      const firstNumber = phoneUtil.parse(rawPhone);
      const countryCode = firstNumber.getCountryCode();
      const regionCode = phoneUtil.getRegionCodeForNumber(firstNumber);

      const e164 = phoneUtil.format(firstNumber, PNF.E164);
      const nationalNumber = phoneUtil.format(firstNumber, PNF.National);
      const internationalNumber = phoneUtil.format(firstNumber, PNF.National);

      return {
        countryCode: regionCode,
        dialCode: `+${countryCode}`,
        e164Number: e164,
        internationalNumber: `+${countryCode} ${internationalNumber}`,
        nationalNumber,
        number: nationalNumber
      };
    } catch (e) {
      return {};
    }
  }

}
